import { t } from '@lingui/core/macro';
import { brands } from 'noddi-types';
import { cn } from 'noddi-ui-common';
import { webButtonStyling } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';

export const LogoLink = ({ children }: { children: ReactNode }) => {
  const { currentBrand } = useCurrentBrand();
  const className = cn('inline-flex origin-left scale-90 p-2 md:scale-100', webButtonStyling);
  // Most brand logos are images or inline SVGs without a text alternative, which
  // leaves the link itself unnamed.
  const label = t`Go to homepage`;

  if (currentBrand === brands.carglass) {
    return (
      <a className={className} href='https://carglass.no/booking' aria-label={label}>
        {children}
      </a>
    );
  }

  return (
    <Link className={className} to={customerRoutes.homepage.getPath()} aria-label={label}>
      {children}
    </Link>
  );
};
